'use strict';

var _regeneratorRuntime = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/regenerator");

var _asyncToGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _asyncGeneratorDelegate = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/asyncGeneratorDelegate");

var _awaitAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/Volumes/ChaosDrive/Backup/Git/ConflictingTheories/_calliope/app/node_modules/react-scripts/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

function _asyncIterator(iterable) { var method, async, sync, retry = 2; if (typeof Symbol !== "undefined") { async = Symbol.asyncIterator; sync = Symbol.iterator; } while (retry--) { if (async && (method = iterable[async]) != null) { return method.call(iterable); } if (sync && (method = iterable[sync]) != null) { return new AsyncFromSyncIterator(method.call(iterable)); } async = "@@asyncIterator"; sync = "@@iterator"; } throw new TypeError("Object is not async iterable"); }

function AsyncFromSyncIterator(s) { AsyncFromSyncIterator = function AsyncFromSyncIterator(s) { this.s = s; this.n = s.next; }; AsyncFromSyncIterator.prototype = { s: null, n: null, next: function next() { return AsyncFromSyncIteratorContinuation(this.n.apply(this.s, arguments)); }, return: function _return(value) { var ret = this.s.return; if (ret === undefined) { return Promise.resolve({ value: value, done: true }); } return AsyncFromSyncIteratorContinuation(ret.apply(this.s, arguments)); }, throw: function _throw(value) { var thr = this.s.return; if (thr === undefined) return Promise.reject(value); return AsyncFromSyncIteratorContinuation(thr.apply(this.s, arguments)); } }; function AsyncFromSyncIteratorContinuation(r) { if (Object(r) !== r) { return Promise.reject(new TypeError(r + " is not an object.")); } var done = r.done; return Promise.resolve(r.value).then(function (value) { return { value: value, done: done }; }); } return new AsyncFromSyncIterator(s); }

Object.defineProperty(exports, '__esModule', {
  value: true
});

var filter = require('it-filter');

var pushable = require('it-pushable');

var drain = require('it-drain');

var cid = require('multiformats/cid');

var errCode = require('err-code');

var identity = require('multiformats/hashes/identity');

function _interopDefaultLegacy(e) {
  return e && typeof e === 'object' && 'default' in e ? e : {
    'default': e
  };
}

var filter__default = /*#__PURE__*/_interopDefaultLegacy(filter);

var pushable__default = /*#__PURE__*/_interopDefaultLegacy(pushable);

var drain__default = /*#__PURE__*/_interopDefaultLegacy(drain);

var errCode__default = /*#__PURE__*/_interopDefaultLegacy(errCode);

function createIdStore(store) {
  return {
    open: function open() {
      return store.open();
    },
    close: function close() {
      return store.close();
    },
    query: function query(_query, options) {
      return store.query(_query, options);
    },
    queryKeys: function queryKeys(query, options) {
      return store.queryKeys(query, options);
    },
    get: function get(cid, options) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var extracted;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                extracted = extractContents(cid);

                if (!extracted.isIdentity) {
                  _context.next = 3;
                  break;
                }

                return _context.abrupt("return", Promise.resolve(extracted.digest));

              case 3:
                return _context.abrupt("return", store.get(cid, options));

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    getMany: function getMany(cids, options) {
      var _this = this;

      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
        var _iteratorAbruptCompletion, _didIteratorError, _iteratorError, _iterator, _step, _cid;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _iteratorAbruptCompletion = false;
                _didIteratorError = false;
                _context2.prev = 2;
                _iterator = _asyncIterator(cids);

              case 4:
                _context2.next = 6;
                return _awaitAsyncGenerator(_iterator.next());

              case 6:
                if (!(_iteratorAbruptCompletion = !(_step = _context2.sent).done)) {
                  _context2.next = 13;
                  break;
                }

                _cid = _step.value;
                _context2.next = 10;
                return _this.get(_cid, options);

              case 10:
                _iteratorAbruptCompletion = false;
                _context2.next = 4;
                break;

              case 13:
                _context2.next = 19;
                break;

              case 15:
                _context2.prev = 15;
                _context2.t0 = _context2["catch"](2);
                _didIteratorError = true;
                _iteratorError = _context2.t0;

              case 19:
                _context2.prev = 19;
                _context2.prev = 20;

                if (!(_iteratorAbruptCompletion && _iterator.return != null)) {
                  _context2.next = 24;
                  break;
                }

                _context2.next = 24;
                return _awaitAsyncGenerator(_iterator.return());

              case 24:
                _context2.prev = 24;

                if (!_didIteratorError) {
                  _context2.next = 27;
                  break;
                }

                throw _iteratorError;

              case 27:
                return _context2.finish(24);

              case 28:
                return _context2.finish(19);

              case 29:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 15, 19, 29], [20,, 24, 28]]);
      }))();
    },
    put: function put(cid, buf, options) {
      return _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _extractContents, isIdentity;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _extractContents = extractContents(cid), isIdentity = _extractContents.isIdentity;

                if (!isIdentity) {
                  _context3.next = 3;
                  break;
                }

                return _context3.abrupt("return");

              case 3:
                _context3.next = 5;
                return store.put(cid, buf, options);

              case 5:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    putMany: function putMany(pairs, options) {
      return _wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6() {
        var output, runner;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                output = pushable__default["default"]();
                runner = globalThis.process && globalThis.process.nextTick ? globalThis.process.nextTick : globalThis.setImmediate || globalThis.setTimeout;
                runner( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
                  return _regeneratorRuntime.wrap(function _callee5$(_context5) {
                    while (1) {
                      switch (_context5.prev = _context5.next) {
                        case 0:
                          _context5.prev = 0;
                          _context5.next = 3;
                          return drain__default["default"](store.putMany(_wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                            var _iteratorAbruptCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _step2$value, key, value;

                            return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                              while (1) {
                                switch (_context4.prev = _context4.next) {
                                  case 0:
                                    _iteratorAbruptCompletion2 = false;
                                    _didIteratorError2 = false;
                                    _context4.prev = 2;
                                    _iterator2 = _asyncIterator(pairs);

                                  case 4:
                                    _context4.next = 6;
                                    return _awaitAsyncGenerator(_iterator2.next());

                                  case 6:
                                    if (!(_iteratorAbruptCompletion2 = !(_step2 = _context4.sent).done)) {
                                      _context4.next = 15;
                                      break;
                                    }

                                    _step2$value = _step2.value, key = _step2$value.key, value = _step2$value.value;

                                    if (extractContents(key).isIdentity) {
                                      _context4.next = 11;
                                      break;
                                    }

                                    _context4.next = 11;
                                    return {
                                      key: key,
                                      value: value
                                    };

                                  case 11:
                                    output.push({
                                      key: key,
                                      value: value
                                    });

                                  case 12:
                                    _iteratorAbruptCompletion2 = false;
                                    _context4.next = 4;
                                    break;

                                  case 15:
                                    _context4.next = 21;
                                    break;

                                  case 17:
                                    _context4.prev = 17;
                                    _context4.t0 = _context4["catch"](2);
                                    _didIteratorError2 = true;
                                    _iteratorError2 = _context4.t0;

                                  case 21:
                                    _context4.prev = 21;
                                    _context4.prev = 22;

                                    if (!(_iteratorAbruptCompletion2 && _iterator2.return != null)) {
                                      _context4.next = 26;
                                      break;
                                    }

                                    _context4.next = 26;
                                    return _awaitAsyncGenerator(_iterator2.return());

                                  case 26:
                                    _context4.prev = 26;

                                    if (!_didIteratorError2) {
                                      _context4.next = 29;
                                      break;
                                    }

                                    throw _iteratorError2;

                                  case 29:
                                    return _context4.finish(26);

                                  case 30:
                                    return _context4.finish(21);

                                  case 31:
                                  case "end":
                                    return _context4.stop();
                                }
                              }
                            }, _callee4, null, [[2, 17, 21, 31], [22,, 26, 30]]);
                          }))()));

                        case 3:
                          output.end();
                          _context5.next = 9;
                          break;

                        case 6:
                          _context5.prev = 6;
                          _context5.t0 = _context5["catch"](0);
                          output.end(_context5.t0);

                        case 9:
                        case "end":
                          return _context5.stop();
                      }
                    }
                  }, _callee5, null, [[0, 6]]);
                })));
                return _context6.delegateYield(_asyncGeneratorDelegate(_asyncIterator(output), _awaitAsyncGenerator), "t0", 4);

              case 4:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }))();
    },
    has: function has(cid, options) {
      var _extractContents2 = extractContents(cid),
          isIdentity = _extractContents2.isIdentity;

      if (isIdentity) {
        return Promise.resolve(true);
      }

      return store.has(cid, options);
    },
    delete: function _delete(cid, options) {
      var _extractContents3 = extractContents(cid),
          isIdentity = _extractContents3.isIdentity;

      if (isIdentity) {
        return Promise.resolve();
      }

      return store.delete(cid, options);
    },
    deleteMany: function deleteMany(cids, options) {
      return store.deleteMany(filter__default["default"](cids, function (cid) {
        return !extractContents(cid).isIdentity;
      }), options);
    },
    batch: function batch() {
      var batch = store.batch();
      return {
        put: function put(cid, buf) {
          var _extractContents4 = extractContents(cid),
              isIdentity = _extractContents4.isIdentity;

          if (isIdentity) {
            return;
          }

          batch.put(cid, buf);
        },
        delete: function _delete(cid) {
          var _extractContents5 = extractContents(cid),
              isIdentity = _extractContents5.isIdentity;

          if (isIdentity) {
            return;
          }

          batch.delete(cid);
        },
        commit: function commit(options) {
          return batch.commit(options);
        }
      };
    }
  };
}

function extractContents(k) {
  var cid$1 = cid.CID.asCID(k);

  if (cid$1 == null) {
    throw errCode__default["default"](new Error('Not a valid cid'), 'ERR_INVALID_CID');
  }

  if (cid$1.multihash.code !== identity.identity.code) {
    return {
      isIdentity: false
    };
  }

  return {
    isIdentity: true,
    digest: cid$1.multihash.digest
  };
}

exports.createIdStore = createIdStore;